import { api, catchHandler } from "../../helpers/axios";
import config from "../../config"

export function sentOtp(payload){
    return api()
    .post(config.routes.sentOtp,payload)
    .then(res => res.data)
    .catch(catchHandler)
}
export function verifyOtp(payload){
    return api()
    .post(config.routes.verifyOtp,payload)
    .then(res => res.data)
    .catch(catchHandler)
}
export function verifyOtpAutoLogin(payload){
    return api()
    .post(config.routes.verifyOtpAutoLogin,payload)
    .then(res => res.data)
    .catch(catchHandler)
}
export function getMe(payload){
    return api()
    .get(config.routes.me)
    .then(res => res.data)
    .catch(catchHandler)
}